import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Line } from 'react-chartjs-2'
import { IPendencyData } from 'services/NGT/Cockpit'
import { COLORS } from 'utils'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

interface LineChart {
  title: string
  data: IPendencyData[]
  labels: string[]
}

const LineChart: React.FC<LineChart> = ({ title = 'Título', data, labels }) => {
  labels = data?.map((item) => item.anoAnalise.toString())
  const values = data?.map((item) => item.vlQuantidade)

  const parseToConvertString = (value: number) => {
    if (value < 1000) {
      return String(value)
    }

    const si = [
      { v: 1E3, s: "K" },
      { v: 1E6, s: "M" },
      { v: 1E9, s: "B" },
      { v: 1E12, s: "T" },
      { v: 1E15, s: "P" },
      { v: 1E18, s: "E" }
    ];
    let index;
    for (index = si.length - 1; index > 0; index--) {
      if (value >= si[index].v) {
        break;
      }
    }
    return (value / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s;
  }

  return (
    <Line
      options={{
        plugins: {
          datalabels: {
            align: (ctx) => {
              // Coloca o datalabel abaixo da marcação no gráfico quando for um buraco,
              // ou seja, o valor anterior e o próximo são maiores que o atual
              const values = ctx.chart.data.datasets[0].data
              const itemIndex = ctx.dataIndex
              const isLessThanPrev = values[itemIndex] < values[itemIndex - 1]
              const isLessThanNext = values[itemIndex] < values[itemIndex + 1]
              if (isLessThanPrev && isLessThanNext) {
                return 'bottom'
              }
              return 'top'
            },
            color: COLORS.info,
            // Realiza a formatação, adicionado pontuação aos valores
            formatter: function (value) {
              return parseToConvertString(value)
            },
            offset: 2
          },
          legend: {
            position: 'bottom' as const
          },
          title: {
            display: true,
            text: title
          }
        },
        responsive: true
      }}
      data={{
        datasets: [
          {
            // Os concats adicionam transparencia a cor hexadecimal
            backgroundColor: COLORS.blueFonts.concat('66'),
            borderColor: COLORS.blueFonts.concat('ab'),
            data: values,
            fill: true,
            label: 'Ano'
          }
        ],
        labels: labels
      }}
      plugins={[ChartDataLabels]}
    />
  )
}

export default LineChart
